export default __webpack_public_path__ + "static/media/menu-notices-active-white.5c68d536.svg";